<script>

import CommonConstants from '@/common/Constants';
import Utils from '@/common/Utils';
import GenericCustomMasterDataAutocompleteV2 from '@/components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import ResponsiveButton from '@/components/generic/ResponsiveButton.vue'
import Service from '@/services/operative-plan'

export default {
    components: {
        GenericCustomMasterDataAutocompleteV2,
        ResponsiveButton
    },
    data(){
        let aR = false;
        if(this.$store.getters['security/uiPermissions']('IsServiceBlending').isEnabled){
            aR = true;
        }

        let idRegistryPlant = null;
        if(this.$store.getters['security/uiPermissions']('OnlyBlendingSud').isEnabled){
            idRegistryPlant = 2;
        }
        if(this.$store.getters['security/uiPermissions']('OnlyBlendingNord').isEnabled){
            idRegistryPlant = 3;
        }
        return{
            filters: {
                referenceDate: Utils.formatDatePlusDays(new Date(), 0),
                idRegistryPlant: idRegistryPlant
            },
            autoRefresh: aR,
            data: [],
            intervalId: null
        }
    },
    created(){
       
    },
    computed: {
        constants() {
            return CommonConstants; 
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        }
    },
    mounted(){
        this.$store.dispatch('security/setNavbarTitle', 'TankTracking.page_title');
        this.loadFromCache();
        this.scheduleCall();
    },
    beforeUnmount(){

    },
    methods: {
        scheduleCall() {
            if(this.autoRefresh){
                setTimeout(() => {
                    if(this.$route.name == 'tank-tracking'){
                        this.load();
                        if(this.autoRefresh){
                            this.scheduleCall();
                        }
                    }
                    
                }, 300000);
            }else{
                this.load();
            }
        },
        setInEdit(item, inEdit){
            item.inEdit = inEdit;
            if(!inEdit){
                this.load();
            }
        },
        loadFromCache(){
            let cacheData = this.$store.getters['cacheDataStore/getGridCache']('TankTrackingGrid');
            if(cacheData){
                this.filters.referenceDate = cacheData.referenceDate;
                this.filters.idRegistryPlant = cacheData.idRegistryPlant;                
            }
            this.load();
        },
        load(){
            let cacheData = {
                name: 'TankTrackingGrid',
                filters: this.filters
            };
            this.$store.dispatch("cacheDataStore/setGridCache", cacheData);

            this.data = [];
            Service.getEquipmentTracking(this.filters, response => {
                if(response.success){
                    this.data = response.data;
                    for(let i=0; i<this.data.loadingOperationTankList.length; i++){
                        this.data.loadingOperationTankList[i].fiscalClearanceDate = this.data.loadingOperationTankList[i].fiscalClearanceDate != null ? Utils.dateToCurrentTimeZone(this.data.loadingOperationTankList[i].fiscalClearanceDate) : null  
                    }
                    for(let i=0; i<this.data.displacementOperationTankList.length; i++){
                        this.data.displacementOperationTankList[i].fiscalClearanceDate = this.data.displacementOperationTankList[i].fiscalClearanceDate != null ? Utils.dateToCurrentTimeZone(this.data.displacementOperationTankList[i].fiscalClearanceDate) : null  
                    }
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        saveItem(item){
            let body = {
                id: item.id,
                fiscalClearanceDate: item.fiscalClearanceDate,
                viewed: item.viewed
            };

            Service.saveEquipmentTracking(body, response => {
                if(response.success){
                    this.$toast.add({detail: this.$t('messages.update_message_success'), life:3000, severity:'success'});
                    this.load();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        }
    }
}
</script>

<template>
    
    <div class="grid">
        <div class="col-12 lg:col-2 field  mt-3 mx-3">
            <label for="from">{{$t('date')}}</label>
            <Calendar
                :class="{'p-inputtext-sm w-full': true}"
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                :dateFormat="constants.DATE_FORMAT_POINT"
                :showTime="false"
                v-model="filters.referenceDate"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
        </div>
        <div class="col-12 lg:col-2 field mt-3 mx-3" v-if="uiPermissions('BlendingSudNord').isEnabled">
            <label for="plant">{{$t('registryPlant.fk')}}</label>
            <GenericCustomMasterDataAutocompleteV2
                field="label"
                v-model="filters.idRegistryPlant"
                api="masterdata/registry-plant-combo"
                :addEmpty="true"
                :emptyValue="null"
                    :name="'registry-plant'"
                :emptyLabel="$t('all')"
                :format="{ label: 'description', value: 'id' }"
                :class="{'p-inputtext-sm w-full': true}" />
        </div>
        <div class="col-12 lg:col-4 field  mt-6">
            <Chip class="p-2 mr-1 accerted-tank" style="min-width:50px; ">
                <span style="margin: 0 auto; font-weight: bold;">{{ $t('TankTracking.available') }}</span>
            </Chip>
            <Chip class="p-2 mr-1 not-accerted-tank" style="min-width:50px; ">
                <span style="margin: 0 auto;" class="not-accerted-tank-label">{{ $t('TankTracking.notAvailable') }}</span>
            </Chip>
            <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="mx-1 p-button-sm" @click="load()"/>
            <Checkbox v-model="autoRefresh" :binary="true" class="ml-2" @change="scheduleCall" />
            <label class="ml-2">{{$t('TankTracking.automaticRefresh')}}</label>
            <RouterLink :to="'/tank-tracking/EquipmentTrackingAudit?referenceDate=' + utils.formatDateForAPIWithTime(filters.referenceDate)" class="p-button mx-1"  v-if="uiPermissions('TankTrackingEditEnabled').isEnabled">{{$t('EquipmentTrackingAudit.page_title') }}</RouterLink>

        </div>


        <div class="col-12">
            <div class="grid">
                <div class="col-12 lg:col-2 md:col-3 xs:col-4" v-for="item in data.loadingOperationTankList" :key="item.id" >
                    <Card :class="{'accerted-tank': item.availableForBlending, 'not-accerted-tank': !item.availableForBlending}" class="m-1" style="border-radius: 15px;">
                        <template #title>
                            <div class="grid">
                                <div class="col-10 ml-3" :class="{'not-accerted-tank-label': !item.availableForBlending}">
                                    {{ item.equipmentCode }} <span v-if="item.equipmentDescription">({{ item.equipmentDescription }})</span>
                                </div>
                            </div>
                        </template>
                        <template #subtitle>
                            <div class="btn-container" v-if="item.isVesselCommunicationPreventive">
                                <i class="fa-solid fa-ship button-right fa-2xl" v-tooltip.left="$t('TankTracking.vesselCommunicationPreventive')" :class="{'ship-primary': item.availableForBlending, 'ship-white': !item.availableForBlending}"></i>
                            </div>
                        </template>
                        <template #content>
                            <div class="grid">
                                <div class="col-12">
                                    <label for="from" class="p-2" :class="{'not-accerted-tank-label': !item.availableForBlending}">{{$t('TankTracking.fiscalClearanceDate')}}</label>
                                    <Calendar 
                                        :dateFormat="constants.DATE_FORMAT_POINT"
                                        :showTime="true" :hideOnDateTimeSelect="true"
                                        :readonly="!item.inEdit"
                                        v-model="item.fiscalClearanceDate"
                                        :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                                        :class="{'w-full p-inputtext-sm mt-1 ': true}" />
                                </div>
                                <div class="col-6">
                                    <Checkbox v-model="item.viewed" :binary="true" :disabled="!item.inEdit" />
                                    <label class="ml-3" :class="{'not-accerted-tank-label': !item.availableForBlending}">{{ $t('TankTracking.viewed') }}</label>
                                </div>
                                
                                <div class="col-5 btn-container" v-if="!item.inEdit" >
                                    <Button icon="pi pi-pencil" class="button-right p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" @click="setInEdit(item, true)" size="small" style="background-color: white;"
                                    v-if="uiPermissions('TankTrackingEditEnabled').isEnabled" />
                                </div>

                                <div class="col-5 btn-container" v-if="item.inEdit">
                                    <Button icon="pi pi-times" class="button-right p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" @click="setInEdit(item, false)" size="small" style="background-color: white;"/>
                                    <Button icon="pi pi-check" class="button-right p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" @click="saveItem(item)" size="small" style="background-color: white;"/>
                                </div>
                            </div>
                        </template>
                    </Card>
                </div>
            </div>
            <Divider align="center" >
                <h2>{{ $t('TankTracking.displacements') }}</h2>
            </Divider>
            
            <div class="grid">
                <div class="col-12 lg:col-2 md:col-3 xs:col-4" v-for="item in data.displacementOperationTankList" :key="item.id" >
                    <Card :class="{'accerted-tank': item.availableForBlending, 'not-accerted-tank': !item.availableForBlending}" class="m-1" style="border-radius: 15px;">
                        <template #title>
                            <div class="grid">
                                <div class="col-10 ml-3" :class="{'not-accerted-tank-label': !item.availableForBlending}">
                                    {{ item.equipmentCode }} <span v-if="item.equipmentDescription">({{ item.equipmentDescription }})</span>
                                </div>
                            </div>
                        </template>
                        <template #subtitle>
                            <div class="btn-container" v-if="item.isVesselCommunicationPreventive">
                                <i class="fa-solid fa-ship button-right fa-2xl" v-tooltip.left="$t('TankTracking.vesselCommunicationPreventive')" :class="{'ship-primary': item.availableForBlending, 'ship-white': !item.availableForBlending}"></i>
                            </div>
                        </template>
                        <template #content>
                            <div class="grid">
                                <div class="col-12">
                                    <label for="from" class="p-2" :class="{'not-accerted-tank-label': !item.availableForBlending}">{{$t('TankTracking.fiscalClearanceDate')}}</label>
                                    <Calendar 
                                        :dateFormat="constants.DATE_FORMAT_POINT"
                                        :showTime="true" :hideOnDateTimeSelect="true"
                                        :readonly="!item.inEdit"
                                        v-model="item.fiscalClearanceDate"
                                        :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                                        :class="{'w-full p-inputtext-sm mt-1 ': true}" />
                                </div>
                                <div class="col-6">
                                    <Checkbox v-model="item.viewed" :binary="true" :disabled="!item.inEdit" />
                                    <label class="ml-3" :class="{'not-accerted-tank-label': !item.availableForBlending}">{{ $t('TankTracking.viewed') }}</label>
                                </div>
                                
                                <div class="col-5 btn-container" v-if="!item.inEdit" >
                                    <Button icon="pi pi-pencil" class="button-right p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" @click="setInEdit(item, true)" size="small" style="background-color: white;"
                                    v-if="uiPermissions('TankTrackingEditEnabled').isEnabled" />
                                </div>

                                <div class="col-5 btn-container" v-if="item.inEdit">
                                    <Button icon="pi pi-times" class="button-right p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" @click="setInEdit(item, false)" size="small" style="background-color: white;"/>
                                    <Button icon="pi pi-check" class="button-right p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" @click="saveItem(item)" size="small" style="background-color: white;"/>
                                </div>
                            </div>
                        </template>
                    </Card>
                </div>
            </div>
        </div>
    </div>
    
</template>

<style scoped>

.accerted-tank{
    background-color: #93faa5;
}

.not-accerted-tank{
    background-color: #ec644b;
}

.not-accerted-tank-label{
    color: white;
    font-weight: bold;
}

.btn-container {
  display: flex;
  justify-content: space-between; /* Distribuisce gli elementi */
  align-items: center; /* Allinea verticalmente */
}

.button-right {
  margin-left: auto; /* Spinge il pulsante all'estrema destra */
}

.p-card .p-card-body{
    padding: 0 1rem;
}

.ship-primary{
    color: var(--primary-color);
}

.ship-white{
    color: white;
}

</style>